<template>
  <button
    type="button"
    class="btn btn-primary btn-floating btn-lg"
    id="btn-back-to-top"
    ref="mybutton"
    @click="backToTop"
  >
    <i class="fas fa-arrow-up"></i>
  </button>
  <Navbar/>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <div>
        <a href="#" class="text-secondary text-decoration-none" @click="isSearchVisible = !isSearchVisible">
          <i class="fas fa-search"></i>
          <span v-show="isSearchVisible" @click="this.searchText = '';getPlaces()">Zamknij wyszukiwanie</span>
          <span v-show="!isSearchVisible">Szukaj</span>
        </a>
        <div v-show="isSearchVisible">
          <input v-model="searchText" type="search" class="form-control" placeholder="Wyszukaj w panelu" @input="getPlaces()">
        </div>
      </div>
      <RefreshButton :refreshing="refreshing"/>
    </div>
    <hr>
    <div class="row">
      <div class="d-lg-flex justify-content-between my-2">
        <h5 class="fw-bold">
          LISTA MIEJSC <span class="text-primary">({{ placesCount }} miejsc w bazie)</span>
        </h5>
        <div class="my-4">
          <router-link to="/miejsca/dodaj" class="btn btn-success">
            Dodaj nowe miejsce
          </router-link>
        </div>
        <div class="my-4">
          <button class="btn btn-primary mx-2" @click="previousPage"><i class="fa-solid fa-circle-arrow-left"></i></button>
          <button class="btn btn-primary mx-2" @click="nextPage"><i class="fa-solid fa-circle-arrow-right"></i></button>
        </div>
        <ImportXlsxPlaces/>
      </div>
    </div>
    <table class="table table-striped">
      <thead>
      <tr>
        <th v-if="canUserEditPlaces">
          <div class="text-center mb-3">
            <button class="btn btn-sm btn-danger" @click="deletePlaces" :disabled="!checked.length">Usuń wybrane miejsca</button>
          </div>
          <input type="checkbox" :checked="checked.length" @change="toggleCheckAll">
        </th>
        <th>Nazwa</th>
        <th>Adres</th>
        <th>Akcje</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="place in places" :key="place">
        <td v-if="canUserEditPlaces">
          <input type="checkbox" :checked="checked.includes(place.id)" @change="toggleCheck(place.id)">
        </td>
        <td>
          {{ place.name }}
        </td>
        <td>
          {{ place.address }}
        </td>
        <td>
          <router-link :to="{ name: 'EditPlace', params: { id: place.id } }" class="btn btn-sm btn-primary">
            Edytuj
          </router-link>
          <button v-if="canUserEditPlaces" @click="deletePlace(place.id)" class="btn btn-sm btn-danger mx-2">
            Usuń
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import axios from 'axios'
import ImportXlsxPlaces from '@/pages/Tasks/ImportXlsxPlaces'
import Swal from 'sweetalert2'
import router from '@/router'
import RefreshButton from '@/components/Layout/RefreshButton.vue'
import emitter from '@/modules/events/emitter'
import eventKinds from '@/modules/events/eventKinds'
import { $axios } from '@/modules/http/axios'
export default {
  name: 'PlacesList',
  components: { RefreshButton, ImportXlsxPlaces, Navbar },
  data () {
    return {
      isSearchVisible: false,
      searchText: '',
      places: [],
      placesCount: 0,
      perPage: 50,
      page: 1,
      canUserEditPlaces: true,
      refreshing: false,
      controller: new AbortController(),
      checked: []
    }
  },
  created () {
    emitter.on('refreshed', this.getPlaces)

    emitter.on(eventKinds.calendarShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.storehouseShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.driverListingShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.tasksListShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.reportsShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.usersShown, () => {
      this.controller.abort()
    })

    window.addEventListener('scroll', this.scrollFunction)
    this.getPlaces()
    const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

    axios.get(`${process.env.VUE_APP_API_BASE_URL}User`, config).then(response => {
      const currentUser = response.data.filter(user => user.name === localStorage.getItem('username'))[0]

      if (!currentUser.permission.canEditMapPoints) {
        this.canUserEditPlaces = false
      }
    })
  },
  methods: {
    getPlaces () {
      this.refreshing = true
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }, signal: this.controller.signal }
      axios.get(`${process.env.VUE_APP_API_BASE_URL}Place`, config).then(response => {
        this.placesCount = response.data.length
        this.places = response.data.slice((this.page - 1) * this.perPage, this.page * this.perPage)
        if (this.searchText !== '') {
          this.places = response.data.filter(place => place.name.toLowerCase().includes(this.searchText.toLowerCase()) || place.address.toLowerCase().includes(this.searchText.toLowerCase())).slice((this.page - 1) * this.perPage, this.page * this.perPage)
        }
      }).catch(error => {
        console.log(error)
      }).finally(() => this.refreshing = false)
    },
    deletePlace (id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      Swal.fire({
        title: 'Usunąć to miejsce?',
        text: 'Jesteś pewien że chcesz usunąć to miejsce?',
        type: 'warning',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'Usuń'
      }).then((result) => {
        if (result.value) {
          axios.delete(`${process.env.VUE_APP_API_BASE_URL}Place/${id}`, config).then(response => {
            Swal.fire('Pomyślnie usunięto miejsce', '', 'success')
            this.getPlaces()
          }).catch(error => {
            console.log(error)
          })
        }
      })
    },
    deletePlaces () {
      if (!this.canUserEditPlaces) {
        return
      }

      const uniqueIds = [...new Set(this.checked)]
      uniqueIds.map(async id => {
        await $axios.delete(`Place/${id}`)
      })
      Swal.fire(`Usunięto ${uniqueIds.length} miejsc`, '', 'success')
      this.checked = []
      this.getPlaces()
    },
    nextPage () {
      this.page++
      this.getPlaces()
      this.checked = []
    },
    previousPage () {
      if (this.page > 1) {
        this.page--
        this.getPlaces()
        this.checked =  []
      }
    },
    scrollFunction () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'block'
        }
      } else {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'none'
        }
      }
    },
    backToTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    toggleCheck (id) {
      if (this.checked.includes(id)) {
        const index = this.checked.indexOf(id)
        this.checked.splice(index, 1)
      } else {
        this.checked.push(id)
      }
    },
    toggleCheckAll () {
      if (this.checked.length) {
        this.checked = []
      } else {
        this.places.map(p => {
          this.checked.push(p.id)
        })
      }
    }
  }
}
</script>

<style scoped>
#btn-back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
}
</style>
